// extracted by mini-css-extract-plugin
export default {"footer":"T5wWVYPYx_pKO3GI1Bs3","footerButton":"CIWrJLVM9rFQiM9S_Jyg"};